import { SharedStyles } from '@opencare/shared-styles';
import styled from 'styled-components';

import { commonInputStyles } from 'brand-guidelines/input-styled-components';

export const DatePickerWrapper = styled.div`
  display: flex;
  gap: 8px;
  width: 100%;
`;

const DateInputField = styled.input.attrs({
  type: 'text',
  inputMode: 'numeric',
})<{ $isInvalid?: boolean; }>`
  ${commonInputStyles}
  text-align: center;

  &::placeholder {
    color: ${SharedStyles.COLOR.TEXT.DEFAULT.PLACEHOLDER};
  }

  /* this removes the number input arrows */
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  &[type=number] {
    -moz-appearance: textfield;
  }
`;

export const DayInput = styled(DateInputField).attrs({
  placeholder: 'DD',
  autoComplete: 'bday-day',
  maxLength: 2,
  'aria-label': 'Birth Day',
})`
  flex: 1;
  min-width: 0;
`;

export const MonthInput = styled(DateInputField).attrs({
  placeholder: 'MM',
  autoComplete: 'bday-month',
  maxLength: 2,
  'aria-label': 'Birth Month',
})`
  flex: 1;
  min-width: 0;
`;

export const YearInput = styled(DateInputField).attrs({
  placeholder: 'YYYY',
  autoComplete: 'bday-year',
  maxLength: 4,
  'aria-label': 'Birth Year',
})`
  flex: 2;
  min-width: 0;
`;
